"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames_1 = require("classnames");
var utils_1 = require("../utils");
var Scrollable = /** @class */ (function (_super) {
    tslib_1.__extends(Scrollable, _super);
    function Scrollable(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onWindowResize = function (e) {
            _this.scrollTo(0, 0);
        };
        _this.onWindowScroll = function (e) {
            var _a = _this.props, stickyOverflowScrollX = _a.stickyOverflowScrollX, strictScrollX = _a.strictScrollX;
            var showX = _this.state.showX;
            if (stickyOverflowScrollX && showX) {
                utils_1.caf(_this.windowScrollRafId);
                _this.windowScrollRafId = utils_1.raf(function () {
                    if (!_this.$scroll) {
                        return;
                    }
                    var rect = _this.$scroll.getBoundingClientRect();
                    var innerHeight = window.innerHeight;
                    var nextState = {
                        fixedScrollX: rect.top + rect.height > innerHeight && rect.top < innerHeight
                    };
                    if (nextState.fixedScrollX !== _this.state.fixedScrollX) {
                        _this.setState(nextState);
                    }
                });
            }
        };
        _this.onDocumentMouseMove = function (e) {
            var onScroll = _this.props.onScroll;
            var _a = _this.state, activeX = _a.activeX, activeY = _a.activeY;
            if (!activeX && !activeY) {
                return;
            }
            var scrollX = _this.$scroll.scrollLeft;
            var scrollY = _this.$scroll.scrollTop;
            utils_1.pauseEvent(e);
            if (activeX) {
                scrollX = _this.startingScrollLeft + _this.scrollBy * (e.pageX - _this.startingMousePageX);
                _this.$scroll.scrollLeft = utils_1.ensureValueInRange(scrollX, { min: 0, max: (_this.$scroll.scrollWidth - _this.$scroll.offsetWidth) });
            }
            if (activeY) {
                scrollY = _this.startingScrollTop + _this.scrollBy * (e.pageY - _this.startingMousePageY);
                _this.$scroll.scrollTop = utils_1.ensureValueInRange(scrollY, { min: 0, max: (_this.$scroll.scrollHeight - _this.$scroll.offsetHeight) });
            }
            _this.updateScrollArea();
            onScroll(scrollX, scrollY);
        };
        _this.onDocumentMouseUp = function (e) {
            var _a = _this.state, activeX = _a.activeX, activeY = _a.activeY;
            if (activeX || activeY) {
                utils_1.pauseEvent(e);
                _this.setState({ activeX: false, activeY: false });
            }
        };
        _this.updateScrollArea = function () {
            if (!_this.$scroll) {
                return;
            }
            var rect = _this.$scroll.getBoundingClientRect();
            var scrollHeight = _this.$scroll.scrollHeight;
            var scrollWidth = _this.$scroll.scrollWidth;
            if (!scrollHeight && !scrollWidth) {
                return;
            }
            var scrollTop = _this.$scroll.scrollTop;
            var scrollLeft = _this.$scroll.scrollLeft;
            var scrollHeightPercent = rect.height / scrollHeight * 100;
            var scrollWidthPercent = rect.width / scrollWidth * 100;
            var nextState = {
                showX: false,
                scrollXPosition: 0,
                scrollWidthPercent: 0,
                scrollLeft: 0,
                showY: false,
                scrollYPosition: 0,
                scrollHeightPercent: 0,
                scrollTop: 0
            };
            if (!isNaN(scrollWidthPercent)) {
                nextState.showX = scrollWidthPercent < 100;
                nextState.scrollXPosition = scrollLeft / scrollWidth * 100;
                nextState.scrollWidthPercent = scrollWidthPercent;
                nextState.scrollLeft = scrollLeft;
            }
            if (!isNaN(scrollHeightPercent)) {
                nextState.showY = scrollHeightPercent < 100;
                nextState.scrollYPosition = scrollTop / scrollHeight * 100;
                nextState.scrollHeightPercent = scrollHeightPercent;
                nextState.scrollTop = scrollTop;
            }
            if (nextState.showX !== _this.state.showX ||
                nextState.scrollWidthPercent !== _this.state.scrollWidthPercent ||
                nextState.scrollLeft !== _this.state.scrollLeft ||
                nextState.scrollXPosition !== _this.state.scrollXPosition ||
                nextState.showY !== _this.state.showY ||
                nextState.scrollHeightPercent !== _this.state.scrollHeightPercent ||
                nextState.scrollTop !== _this.state.scrollTop ||
                nextState.scrollYPosition !== _this.state.scrollYPosition) {
                _this.setState(nextState);
            }
        };
        _this.onScroll = function (e) {
            var onScroll = _this.props.onScroll;
            var _a = _this.state, showX = _a.showX, showY = _a.showY;
            if (!showX && !showY) {
                return;
            }
            var _b = _this.props, disableScrollX = _b.disableScrollX, disableScrollY = _b.disableScrollY;
            var scrollTop = _this.$scroll.scrollTop;
            var scrollLeft = _this.$scroll.scrollLeft;
            var _c = utils_1.getDeltaFromEvent(e), deltaX = _c[0], deltaY = _c[1];
            var nextScrollTop = scrollTop + deltaY;
            var nextScrollLeft = scrollLeft + deltaX;
            var scrollXChanged = false;
            var scrollYChanged = false;
            if (!disableScrollX) {
                var scrollWidth = _this.$scroll.scrollWidth;
                var width = _this.$scroll.offsetWidth;
                scrollXChanged = (deltaX < 0 && nextScrollLeft + scrollLeft > 0) || (deltaX > 0 && scrollLeft + width < scrollWidth);
                if (scrollXChanged) {
                    _this.$scroll.scrollLeft = nextScrollLeft;
                }
            }
            if (!disableScrollY) {
                var scrollHeight = _this.$scroll.scrollHeight;
                var height = _this.$scroll.offsetHeight;
                scrollYChanged = (deltaY < 0 && nextScrollTop + scrollTop > 0) || (deltaY > 0 && scrollTop + height < scrollHeight);
                if (scrollYChanged) {
                    _this.$scroll.scrollTop = nextScrollTop;
                }
            }
            if (scrollXChanged || scrollYChanged) {
                onScroll(nextScrollLeft, nextScrollTop);
                _this.updateScrollArea();
                if (!e.ctrlKey &&
                    (!disableScrollY && !disableScrollX ||
                        disableScrollY && Math.abs(deltaY) <= Math.abs(deltaX) ||
                        disableScrollX && Math.abs(deltaX) <= Math.abs(deltaY))) {
                    utils_1.pauseEvent(e);
                }
            }
        };
        _this.onTrainYMouseDown = function (e) {
            var event = e.nativeEvent;
            utils_1.pauseEvent(event);
            var trainRect = _this.$trainY.getBoundingClientRect();
            _this.startingScrollTop = _this.$scroll.scrollTop;
            _this.startingMousePageY = event.pageY;
            _this.scrollBy = (_this.$scroll.scrollHeight - _this.$scroll.offsetHeight) / (_this.$scroll.offsetHeight - trainRect.height);
            _this.setState({
                activeY: true
            });
        };
        _this.onTrainXMouseDown = function (e) {
            var event = e.nativeEvent;
            utils_1.pauseEvent(event);
            var trainRect = _this.$trainX.getBoundingClientRect();
            _this.startingScrollLeft = _this.$scroll.scrollLeft;
            _this.startingMousePageX = event.pageX;
            _this.scrollBy = (_this.$scroll.scrollWidth - _this.$scroll.offsetWidth) / (_this.$scroll.offsetWidth - trainRect.width);
            _this.setState({
                activeX: true
            });
        };
        _this.childScrollTo = function (x, y) {
            _this.scrollTo(x, y, true);
        };
        _this.scrollTo = function (x, y, fromChild) {
            var onScroll = _this.props.onScroll;
            !isNaN(x) && (_this.$scroll.scrollLeft = x);
            !isNaN(y) && (_this.$scroll.scrollTop = y);
            _this.updateScrollArea();
            if (!fromChild) {
                onScroll(x, y);
            }
        };
        _this.setExposedRef = function (el) {
            var exposedRef = _this.props.exposedRef;
            _this.$scroll = el;
            exposedRef && exposedRef(el);
        };
        _this.setTrainXRef = function (el) {
            _this.$trainX = el;
        };
        _this.setTrainYRef = function (el) {
            _this.$trainY = el;
        };
        _this.onMouseEnter = function () {
            _this.mouseOver = true;
        };
        _this.onMouseLeave = function () {
            _this.mouseOver = false;
        };
        _this.$scroll = null;
        _this.$trainX = null;
        _this.$trainY = null;
        _this.mouseOver = false;
        _this.windowScrollRafId = null;
        _this.state = { showX: false, showY: false, scrollHeightPercent: 0, scrollWidthPercent: 0, scrollTop: 0, scrollLeft: 0, scrollXPosition: 0, scrollYPosition: 0, activeX: false, activeY: false };
        if (process.env.NODE_ENV === "development") {
            console.warn("Deprecation Warning: <Scrollable /> component is going to be deprecated, use <NativeScrollable /> if possible.");
        }
        return _this;
    }
    Scrollable.prototype.getChildContext = function () {
        return {
            scrollTo: this.childScrollTo
        };
    };
    Scrollable.prototype.componentDidMount = function () {
        var onRef = this.props.onRef;
        this.$scroll.addEventListener(utils_1.mouseWheelEvent(), this.onScroll, false);
        window.addEventListener("scroll", this.onWindowScroll, { passive: true });
        window.addEventListener("resize", this.onWindowResize, false);
        utils_1.addEventsToDocument(this.getMouseEventMap());
        utils_1.raf(this.updateScrollArea);
        onRef && onRef(this);
    };
    Scrollable.prototype.componentWillUnmount = function () {
        var onRef = this.props.onRef;
        this.$scroll.removeEventListener(utils_1.mouseWheelEvent(), this.onScroll, false);
        window.removeEventListener("scroll", this.onWindowScroll, { passive: true });
        window.removeEventListener("resize", this.onWindowResize, false);
        utils_1.removeEventsFromDocument(this.getMouseEventMap());
        onRef && onRef(undefined);
    };
    Scrollable.prototype.componentDidUpdate = function () {
        // this.updateScrollArea();
    };
    Scrollable.prototype.getMouseEventMap = function () {
        return {
            mousemove: this.onDocumentMouseMove,
            mouseup: this.onDocumentMouseUp
        };
    };
    Scrollable.prototype.renderXScrollBar = function () {
        var _a = this.props, theme = _a.theme, scrollSize = _a.scrollSize, stickyOverflowScrollX = _a.stickyOverflowScrollX;
        var _b = this.state, scrollTop = _b.scrollTop, scrollLeft = _b.scrollLeft, scrollXPosition = _b.scrollXPosition, scrollWidthPercent = _b.scrollWidthPercent, fixedScrollX = _b.fixedScrollX;
        var translateY = scrollTop;
        var translateX = scrollLeft;
        var railXStyles = {
            height: scrollSize + "rem"
        };
        if (stickyOverflowScrollX && fixedScrollX) {
            var rect = this.$scroll.getBoundingClientRect();
            translateY = 0;
            translateX = 0;
            railXStyles.position = "fixed";
            railXStyles.left = rect.left;
            railXStyles.width = rect.width;
            railXStyles.bottom = 0;
        }
        railXStyles.transform = "translateX(" + translateX + "px) translateY(" + translateY + "px)";
        var trainXStyles = {
            height: scrollSize + "rem",
            width: scrollWidthPercent + "%",
            left: scrollXPosition + "%"
        };
        return (React.createElement("div", { className: classnames_1.default(theme.rail, theme["rail-x"]), style: railXStyles },
            React.createElement("div", { ref: this.setTrainXRef, className: classnames_1.default(theme.train, theme["train-x"]), style: trainXStyles, onMouseDown: this.onTrainXMouseDown })));
    };
    Scrollable.prototype.renderYScrollBar = function () {
        var _a = this.props, theme = _a.theme, scrollSize = _a.scrollSize;
        var _b = this.state, scrollTop = _b.scrollTop, scrollLeft = _b.scrollLeft, scrollYPosition = _b.scrollYPosition, scrollHeightPercent = _b.scrollHeightPercent;
        var railYStyles = {
            transform: "translateY(" + scrollTop + "px) translateX(" + scrollLeft + "px)",
            width: scrollSize + "rem"
        };
        var trainYStyles = {
            height: scrollHeightPercent + "%",
            width: scrollSize + "rem",
            top: scrollYPosition + "%"
        };
        return (React.createElement("div", { className: classnames_1.default(theme.rail, theme["rail-y"]), style: railYStyles },
            React.createElement("div", { ref: this.setTrainYRef, className: classnames_1.default(theme.train, theme["train-y"]), style: trainYStyles, onMouseDown: this.onTrainYMouseDown })));
    };
    Scrollable.prototype.render = function () {
        var _a;
        var _b = this.props, children = _b.children, theme = _b.theme, bold = _b.bold, width = _b.width, height = _b.height, scrollSize = _b.scrollSize, className = _b.className, disableScrollX = _b.disableScrollX, disableScrollY = _b.disableScrollY, strictScrollX = _b.strictScrollX, strictScrollY = _b.strictScrollY;
        var _c = this.state, showX = _c.showX, showY = _c.showY, scrollHeightPercent = _c.scrollHeightPercent, scrollWidthPercent = _c.scrollWidthPercent, scrollTop = _c.scrollTop, scrollLeft = _c.scrollLeft, scrollXPosition = _c.scrollXPosition, scrollYPosition = _c.scrollYPosition, activeX = _c.activeX, activeY = _c.activeY;
        var classes = classnames_1.default(theme.scrollable, className, (_a = {},
            _a[theme.bold] = bold,
            _a[theme["active-x"]] = activeX,
            _a[theme["active-y"]] = activeY,
            _a[theme["strict-x"]] = strictScrollX,
            _a[theme["strict-y"]] = strictScrollY,
            _a));
        var styles = {
            width: isNaN(width) ? width : width + "rem",
            height: isNaN(height) ? height : height + "rem",
        };
        return (React.createElement("div", { className: classes, style: styles, ref: this.setExposedRef, onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave },
            children,
            showY && !disableScrollY ? this.renderYScrollBar() : null,
            showX && !disableScrollX ? this.renderXScrollBar() : null));
    };
    Scrollable.defaultProps = {
        scrollSize: .4,
        onScroll: utils_1.noop
    };
    Scrollable.childContextTypes = {
        scrollTo: PropTypes.func
    };
    return Scrollable;
}(React.Component));
exports.default = Scrollable;
